import { render, staticRenderFns } from "./SearchBlock.vue?vue&type=template&id=2a5720ba&scoped=true&"
import script from "./SearchBlock.vue?vue&type=script&lang=js&"
export * from "./SearchBlock.vue?vue&type=script&lang=js&"
import style0 from "./SearchBlock.vue?vue&type=style&index=0&id=2a5720ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5720ba",
  null
  
)

export default component.exports